// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const PhoneCallsAPI = {
    HealthCheck(fn, req) {
        return fn(`/phone-exp/phone-call/v1/health-check?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Dial(fn, req) {
        return fn(`/phone-exp/phone-call/v1/dial`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // AttachSpans : endpoint for adding call pops frontend spans in the trace.
    CollectSpans(fn, req) {
        return fn(`/phone-exp/phone-call/v1/collect-spans`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListCallQueues(fn, req) {
        return fn(`/phone-exp/phone-call/v1/call-queues`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // we are planning on limiting the number of call ids that can be passed in to 50 so this is a post
    GetCallQueueMetrics(fn, req) {
        return fn(`/phone-exp/phone-call/v1/call-queues/metrics`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SubscribeUserToQueues(fn, req) {
        return fn(`/phone-exp/phone-call/v1/call-queues/subscribe-to-queues`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
